import React, { Component } from 'react'
import { connect } from 'react-redux'
import { shape, string, func } from 'prop-types'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

import './PopUp.scss'

import { contactUs as sendForm, resetContactUs } from './../../modules/Home'
import { TextField, TextAreaField, SelectField } from '../Fields'
import sortByProperty from '../../utils/sort'

const userRoles = sortByProperty([{
  id: 'pembudidaya',
  name: 'Pembudidaya',
}, {
  id: 'perdagangan-hasil-perikanan',
  name: 'Perdagangan Hasil Perikanan',
}, {
  id: 'pengolahan-hasil-perikanan',
  name: 'Pengolahan Hasil Perikanan',
}, {
  id: 'supplier-sarana-prasarana',
  name: 'Supplier Sarana Prasarana',
}, {
  id: 'institusi-pendidikan',
  name: 'Institusi Pendidikan',
}, {
  id: 'pemerintah-dinas-upt',
  name: 'Pemerintah/Dinas/UPT',
}, {
  id: 'institusi-lainnya',
  name: 'Institusi Lainnya',
}, {
  id: 'pelajar-mahasiswa',
  name: 'Pelajar Mahasiswa',
}, {
  id: 'media-massa',
  name: 'Media Massa',
}, {
  id: 'masyarakat-umum',
  name: 'Masyarakat Umum',
}], 'name')

class Slider extends Component {
  state = {
    fields: {
      name: '',
      email: '',
      phone: '',
      occupation: '',
      subject: '',
      message: '',
    },
    error: {},
  }

  componentDidUpdate() {
    if (this.props.contactUs.message) {
      setTimeout(() => {
        this.clearState()
        this.props.resetContactUs()
      }, 5000)
    }
  }

  onChangeValidate = (name, values) => {
    const err = this.validate(name, values)
    if (err !== null) {
      this.setState({
        error: ({ ...this.state.error, ...{ [`${name}`]: err } }),
      })
    } else {
      const error = this.state.error
      delete error[`${name}`]
      this.setState({
        error,
      })
    }
  }

  handleOnFieldFocus = (e) => {
    const error = this.state.error
    if (error[`${e.target.name}`]) {
      delete error[`${e.target.name}`]
    }
    this.setState({
      error,
    })
  }

  handleOnFieldBlur = (e) => {
    this.onChangeValidate(e.target.name, e.target.value)
  }

  handleOnFieldChange = (e) => {
    const name = e.target.name
    const vals = e.target.value
    this.setState({
      fields: ({ ...this.state.fields, ...{ [`${name}`]: vals } }),
    }, () => {
      // this.onChangeValidate(name, vals)
    })
  }

  validate = (fields, values) => {
    let err = null
    if (fields === 'name') {
      if (values === '') {
        err = 'Nama tidak boleh kosong'
      }
    }
    if (fields === 'email') {
      if (values === '') {
        err = 'Email tidak boleh kosong'
      }
      if (!values.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i)) {
        err = 'Email tidak sesuai format'
      }
    }

    if (fields === 'occupation') {
      if (values === '') {
        err = 'Harap pilih sebagai seller / buyer'
      }
    }

    if (fields === 'subject') {
      if (values === '') {
        err = 'Subjek tidak boleh kosong'
      }
    }

    if (fields === 'message') {
      if (values === '') {
        err = 'Pesan tidak boleh kosong'
      }
    }


    return err
  }

  handleSend = () => {
    if (Object.keys(this.state.error).length === 0 && this.state.error.constructor === Object) {
      const tifOptions = Object.keys(this.state.fields).map((key) => {
        const err = this.validate(key, this.state.fields[`${key}`])
        if (err !== null) {
          this.setState({
            error: ({ ...this.state.error, ...{ [`${key}`]: err } }),
          })
          return false
        }
        return true
      })

      const filtered = tifOptions.filter(x => x === false)
      if (filtered.length === 0) {
        const variables = {
          name: this.state.fields.name,
          email: this.state.fields.email,
          phone: this.state.fields.phone,
          occupation: this.state.fields.occupation,
          subject: this.state.fields.subject,
          message: this.state.fields.message,
        }

        this.props.sendForm(variables)
      }
    }
  }

  clearState = () => {
    this.setState({
      fields: {
        name: '',
        email: '',
        phone: '',
        occupation: '',
        subject: '',
        message: '',
      },
      error: {},
    })
  }

  render() {
    const { contactUs, contactUsError } = this.props

    return (
      <div className='popup__form'>
        { contactUsError && <div className='alert alert-danger'>{contactUsError}</div> }
        <TextField
          customClass='margin-tp-10'
          label={'Nama'}
          name={'name'}
          type={'text'}
          error={this.state.error.name}
          handleOnFieldFocus={this.handleOnFieldFocus}
          handleOnFieldChange={this.handleOnFieldChange}
          handleOnFieldBlur={this.handleOnFieldBlur}
          value={this.state.fields.name}
          tabIndex={0} />
        <TextField
          customClass='margin-tp-10'
          label={'Email'}
          name={'email'}
          type={'email'}
          error={this.state.error.email}
          handleOnFieldFocus={this.handleOnFieldFocus}
          handleOnFieldChange={this.handleOnFieldChange}
          handleOnFieldBlur={this.handleOnFieldBlur}
          value={this.state.fields.email}
          tabIndex={0} />
        <TextField
          customClass='margin-tp-10'
          label={'No Telefon'}
          name={'phone'}
          type={'number'}
          error={this.state.error.phone}
          handleOnFieldFocus={this.handleOnFieldFocus}
          handleOnFieldChange={this.handleOnFieldChange}
          handleOnFieldBlur={this.handleOnFieldBlur}
          value={this.state.fields.phone}
          tabIndex={0} />
        <SelectField
          customClass='margin-tp-10'
          defaultLabels={'Anda Sebagai'}
          selectData={userRoles}
          name={'occupation'}
          error={this.state.error.occupation}
          handleOnFieldFocus={this.handleOnFieldFocus}
          handleOnFieldChange={this.handleOnFieldChange}
          handleOnFieldBlur={this.handleOnFieldBlur}
          value={this.state.fields.occupation}
          tabIndex={0} />
        <TextField
          customClass='margin-tp-10'
          label={'Subjek'}
          name={'subject'}
          type={'text'}
          error={this.state.error.subject}
          handleOnFieldFocus={this.handleOnFieldFocus}
          handleOnFieldChange={this.handleOnFieldChange}
          handleOnFieldBlur={this.handleOnFieldBlur}
          value={this.state.fields.subject}
          tabIndex={0} />
        <TextAreaField
          customClass='margin-tp-10'
          label={'Pesan'}
          name={'message'}
          type={'text'}
          error={this.state.error.message}
          handleOnFieldFocus={this.handleOnFieldFocus}
          handleOnFieldChange={this.handleOnFieldChange}
          handleOnFieldBlur={this.handleOnFieldBlur}
          value={this.state.fields.message}
          tabIndex={0} />
        {
          contactUs.message ? (
            <button
              type='button'
              className='submit__button'>
              Sukses Mengirim!
              <FontAwesomeIcon icon='check' color='white' />
            </button>
          ) : (
            <button
              type='button'
              className='submit__button'
              onClick={this.handleSend}>Kirim
            </button>
          )
        }
      </div>
    )
  }
}

Slider.defaultProps = {
  contactUsError: '',
  contactUs: {},
  resetContactUs: () => {},
}
Slider.propTypes = {
  contactUsError: string,
  contactUs: shape({
    message: string,
  }),
  sendForm: func.isRequired,
  resetContactUs: func,
}

const mapStateToProps = state => ({
  contactUs: state.home.contactUs,
  contactUsError: state.home.contactUsError,
})
const mapDispatchToProps = {
  sendForm,
  resetContactUs,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Slider)



// WEBPACK FOOTER //
// ./src/common/Modals/ContactUs.js